import { withTranslation } from "next-i18next";
import FaqArticlesList from "../FaqArticlesList";

function ArticlesFeaturedSection({ faqFeaturedArticles, t }) {
  return (
    <div className="flex-1 d-flex flex-column">
      <div className="mb-3">
        <h2 className="h3 mb-0 text-center">{t("help:help_center.articles_featured.title")}</h2>
        <p className="mb-0 text-center font-size-sm">{t("help:help_center.articles_featured.subtitle")}</p>
      </div>

      <div className="mx-md-3">
        <FaqArticlesList faqArticles={faqFeaturedArticles} />
      </div>
    </div>
  );
}

export default withTranslation("help")(ArticlesFeaturedSection);